import type { FunctionComponent } from 'react';
import * as styles from './Title.module.css';

interface TitleProps {
  isDesktop: boolean;
}

const Title: FunctionComponent<TitleProps> = ({ isDesktop }) => {
  if (isDesktop) return <h1 className={styles.title}>We Don’t Want to Break Up!</h1>;
  return (
    <h1 className={styles.title}>
      We Don’t Want to
      <br data-testid="br" />
      Break Up!
    </h1>
  );
};

export default Title;
